module.exports = __webpack_public_path__ + "static/google-63cd5484da51dff07f5540bce23608a4.svg";